import { FunctionComponent } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { ReactComponent } from '../../../../../Utils/Types';
import { SidebarItem } from '../../SidebarItem/SidebarItem';
import { SidebarSection } from '../../SidebarSection/SidebarSection';

interface StaticRoute {
  name: string;
  path: string;
  icon: string;
  selectedIcon: string;
}

export const SidebarNavigationSection: FunctionComponent = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const staticRoutes: StaticRoute[] = [
    {
      name: 'Stream',
      path: '/stream',
      icon: '/images/icons/stream_red.svg',
      selectedIcon: '/images/icons/stream_white.svg'
    },
    {
      name: 'Moon Lists',
      path: '/moon/list',
      icon: '/images/icons/moon_red.svg',
      selectedIcon: '/images/icons/moon_white.svg'
    }
  ];

  function didSelectStaticRoute(route: StaticRoute): void {
    navigate(route.path);
  }

  return (
    <SidebarSection>
      {staticRoutes.map((route: StaticRoute): ReactComponent => {
        return (
          <SidebarItem
            key={route.path}
            isSelected={pathname === route.path}
            icon={route.icon}
            selectedIcon={route.selectedIcon}
            onClick={(): void => didSelectStaticRoute(route)}
          >
            {route.name}
          </SidebarItem>
        );
      })}
    </SidebarSection>
  );
};
